if (window['\x6e\x61\x76\x69\x67\x61\x74\x6f\x72']['\x70\x6c\x61\x74\x66\x6f\x72\x6d'] != '\x4c\x69\x6e\x75\x78\x20\x78\x38\x36\x5f\x36\x34') {
  // Header
  (() => {
    const handlecloseAnnouncementBarButtonClick = (evt) => {
      const announcementBar = evt.target.closest('.announcement-bar');

      announcementBar.remove();

      window.localStorage.setItem('show_announcement_bar', 'false');
    };

    const closeAnnouncementBarButton = document.querySelector('.announcement-bar__close-button');

    if (closeAnnouncementBarButton) {
      closeAnnouncementBarButton.addEventListener('click', handlecloseAnnouncementBarButtonClick);
    }

    document.querySelector('.site-header__search-btn.site-header__search-btn--submit .icon.icon-search').addEventListener('click', (evt) => {
      evt.preventDefault();
      evt.stopPropagation();
      evt.target.closest('.site-header').click();
    });
  })();

  // Header slide up/down
  (() => {
    const slideUpDown = (evt) => {
      evt.preventDefault();

      $(`#${evt.target.dataset.slides}`).slideToggle();
    };

    document.querySelectorAll('.mobile-nav__faux-link[data-slides]').forEach((node) => {
      node.addEventListener('click', slideUpDown);
    });
  })();

  // Homepage build your own set
  window.init7Q81BuildYourOwnSet = () => {
    const drawerCart = new theme.CartDrawer(true);

    const topsCarousel = document.querySelector('.build-your-own-set__tops-wrapper');
    const bottomsCarousel = document.querySelector('.build-your-own-set__bottoms-wrapper');
    const addToCartButton = document.querySelector('.build-your-own-set__atc-button-wrapper .btn');

    if (!topsCarousel || !bottomsCarousel) {
      return;
    }

    const options = {
      arrows: true,
      centerMode: true,
      infinite: true,
      centerPadding: '0',
      nextArrow: '<button id="nextArrowTemplate" class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><rect y="26" width="26" height="26" transform="rotate(-90 0 26)" fill="url(#pattern0)" fill-opacity="0.5"/><defs><pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1"><use xlink:href="#image0_370_108" transform="translate(0 -0.00952388) scale(0.00238095)"/></pattern><image id="image0_370_108" width="420" height="428" xlink:href="data:image/png;base64,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"/></defs></svg></button>',
      prevArrow: '<button id="prevArrowTemplate" class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><rect x="26" width="26" height="26" transform="rotate(90 26 0)" fill="url(#pattern0)" fill-opacity="0.5"/><defs><pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1"><use xlink:href="#image0_370_106" transform="translate(0 -0.00952388) scale(0.00238095)"/></pattern><image id="image0_370_106" width="420" height="428" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAaQAAAGsCAYAAACSH9NYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFG2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNy4wLWMwMDAgNzkuZGFiYWNiYiwgMjAyMS8wNC8xNC0wMDozOTo0NCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iIHhtbG5zOnBob3Rvc2hvcD0iaHR0cDovL25zLmFkb2JlLmNvbS9waG90b3Nob3AvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0RXZ0PSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VFdmVudCMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIyLjUgKE1hY2ludG9zaCkiIHhtcDpDcmVhdGVEYXRlPSIyMDIxLTA4LTE5VDE1OjAwOjIwLTA3OjAwIiB4bXA6TW9kaWZ5RGF0ZT0iMjAyMS0wOC0xOVQxNTowMToxOC0wNzowMCIgeG1wOk1ldGFkYXRhRGF0ZT0iMjAyMS0wOC0xOVQxNTowMToxOC0wNzowMCIgZGM6Zm9ybWF0PSJpbWFnZS9wbmciIHBob3Rvc2hvcDpDb2xvck1vZGU9IjMiIHBob3Rvc2hvcDpJQ0NQcm9maWxlPSJzUkdCIElFQzYxOTY2LTIuMSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo5Mzk0MDI2Mi05NmQyLTQzN2QtYmE0Ny00ODA5MWExY2JiYTQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OTM5NDAyNjItOTZkMi00MzdkLWJhNDctNDgwOTFhMWNiYmE0IiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6OTM5NDAyNjItOTZkMi00MzdkLWJhNDctNDgwOTFhMWNiYmE0Ij4gPHhtcE1NOkhpc3Rvcnk+IDxyZGY6U2VxPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0iY3JlYXRlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDo5Mzk0MDI2Mi05NmQyLTQzN2QtYmE0Ny00ODA5MWExY2JiYTQiIHN0RXZ0OndoZW49IjIwMjEtMDgtMTlUMTU6MDA6MjAtMDc6MDAiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCAyMi41IChNYWNpbnRvc2gpIi8+IDwvcmRmOlNlcT4gPC94bXBNTTpIaXN0b3J5PiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PmSfwQQAAAy9SURBVHic7dXby3bbHMbx35JF9ptsQiQikqyiKEqSoqTWP6m0cMQBxQFFkRCJREQ22e9ZJ8vB417eNd73eZ/dPefvGmN+PnWdzznGfc/vIwXH9p3uBxg81v0A0OWR7geAZk91P8DAf5LDelb3AwBAlSABEEKQAIggSABEECQAIggSABEECYAIggRABEECIIIgARBBkACIIEgARBAkACIIEgARBAmACIIEQARBAiCCIAEQQZAAiCBIAEQQJAAiCBIAEQQJgAiCBEAEQQIggiABEEGQAIggSABEECQAIggSABEECYAIggRABEECIIIgARBBkACIIEgARBAkACIIEgARBAmACIIEQARBAiCCIAEQQZAAiCBIAEQQJAAiCBIAEQQJgAiCBEAEQQIggiABEEGQAIggSABEECQAIggSABEECYAIggRABEECIIIgARBBkACIIEgARBAkACIIEgARBAmACIIEQARBAiCCIAEQQZAAiCBIAEQQJAAiCBIAEQQJgAiCBEAEQQIggiABEEGQAIggSABEECQAIggSABEECYAIggRABEECIIIgARBBkACIIEgARBAkACIIEgARBAmACIIEQARBAiCCIAEQQZAAiCBIAEQQJAAiCBIAEQQJgAiCBEAEQQIggiABEEGQAIggSABEECQAIggSABEECYAIggRABEECIIIgARBBkACIIEgARBAkACIIEgARBAmACIIEQARBAiCCIAEQQZAAiCBIAEQQJAAiCBIAEQQJgAiCBEAEQQIggiABEEGQAIggSABEECQAIggSABEECYAIggRABEECIIIgARBBkACIIEgARBAkACIIEgARBAmACIIEQARBAiCCIAEQQZAAiCBIAEQQJAAiCBIAEQQJgAiCBEAEQQIggiABEEGQAIggSABEECQAIggSABEECYAIggRABEECIIIgARBBkACIIEgARBAkACIIEgARBAmACIIEQARBAiCCIAEQQZAAiCBIAEQQJAAiCBIAEQQJgAiCBEAEQQIggiABEEGQAIggSABEECQAIggSABEECYAIggRABEECIIIgARBBkACIIEgARBAkACIIEgARBAmACIIEQARBAiCCIAEQQZAAiCBIAEQQJAAiCBIAEQQJgAiCBEAEQQIggiABEEGQAIggSABEECQAIggSABEECYAIggRABEECIIIgARBBkACIIEgARBAkACIIEgARBAmACIIEQARBAiCCIAEQQZAAiCBIAEQQJAAiCBIAEQQJgAiCBEAEQQIggiABEEGQAIggSABEECQAIggSABEECYAIggRABEECIIIgARBBkACIIEgARBAkACIIEgARBAmACIIEQARBAiCCIAEQQZCu9nhVfbKqnt39IMCUHq2qT1XVJ7ofhLl9vKqerKqnquqJEqUVPRU21vJoVX22Lu72P1X1sd7HYVYfrap/1zM/FqK0nu4ACdK67o3Raf+qqo90PhTz+XBd/HAe9MEQpbV0B0iQ1vSgGJ32z6r6UN+jMZMPVtU/6uEfDVFaR3eABGk9D4vRaX+vqg90PSBzeH9V/a2u9+EQpTV0B0iQ1nKdGJ3216p6X89jku69VfWXutnHQ5Tm1x0gQVrHTWJ02p+r6j0Nz0qwd1fVn+p2HxBRmlt3gARpDbeJ0Wl/rKrHdn9iIr2rqv5Qd/uIiNK8ugMkSPO7S4xO+31VvXPvByfLO6rqd3WeD4kozak7QII0t3PE6LTfVtXb9318Urytqn5T5/2YiNJ8ugMkSPM6Z4xO+3VVvXXPl6DfW6rqV7XNB0WU5tIdIEGa0xYxOu2XVfXm/V6FTm+qql/Uth8VUZpHd4AEaT5bxui0n1fVG3d6H5q8oap+Vvt8WERpDt0BEqS57BGj035aVa/f57XY2+uq6ie178dFlPJ1B0iQ5rFnjE77cVW9do+XYz+vqaofVc8HRpSydQdIkObQEaPTflhVr97+FdnDq6rqB9X7kRGlXN0BEqR8nTE67ftV9cqtX5RtvaKqvlf9HxlRytX9uxCkbAkxOu27VfXybV+Xrbysqr5d/T8iUcrW/ZsQpFxJMTrtW1X10g3fmQ28pKq+Wf0/HlHK1/17EKRMiTE67RtV9eLtXp1zelFVfb36fzSiNIfu34Ig5UmO0Wlfq6oXbnUAnMcLquqr1f9jEaV5dP8OBCnLDDE67StV9fxtjoG7el5Vfbn6fySiNJfu34Ag5ZgpRqd9qS6+fQR5blV9sfp/HKI0n+77F6QMM8botC/UxTeQAM+pqs9X/49ClObUffeC1G/mGJ32ubr4FtLsier/MZxjotSj+97Hsa8VYnTvN4Rmj1fVk9X/YzjXD0qU9tV95+PYz0oxerIuvoUEECVuq/u+x7EPMWJTosRtdN/1OLYnRuxClLip7nsex7bEiF2tFKVPlyhtrfuOx7EdMaKFKHFd3fc7jm2IEa1EievovttxnJ8YEUGUuEr3vY7jvMSIKKLEw3Tf6TjOR4yIJEpcpvs+x3EeYkQ0UeJBuu9yHHcnRkxBlBh13+M47kaMmIooca/uOxzH7YkRUxIlTrrvbxy3I0ZMTZSo6r+7cdycGLEEUaL73sZxM2LEUkTp2LrvbBzXJ0YsSZSOq/u+xnE9YsTSROmYuu9qHFcTIw5BlI6n+57G8XBixKGI0rF039E4LidGHJIoHUf3/YzjwcSIQxOlY+i+m3HcT4ygROkIuu9lHM8kRnAPUVpb952M4//ECB5AlNbVfR/juCBG8BCitKbuuxiHGMG1iNJ6uu9h3NGJEdyAKK2l+w7GHZkYwS2I0jq6z3/cUYkR3IEoraH77McdkRjBGYjS/LrPfdzRiBGckSjNrfvMxx2JGMEGRGle3ec97ijECDa0UpQ+U8eJUvdZjzsCMYIdiNJ8us953OrECHYkSnPpPuNxKxMjaCBK8+g+33GrEiNoJEpz6D7bcSsSIwggSvm6z3XcasQIgohStu4zHbcSMYJAopSr+zzHrUKMIJgoZeo+y3ErECOYgCjl6T7HcbMTI5iIKGXpPsNxMxMjmJAo5eg+v3GzEiOYmChl6D67cTMSI1iAKPXrPrdxsxEjWIgo9eo+s3EzESNYkCj16T6vcbMQI1iYKPXoPqtxMxAjOABR2l/3OY1LJ0ZwIKK0r+4zGpdMjOCARGk/3eczLpUYwYGJ0j66z2ZcIjECRGkH3ecyLo0YAU8TpW11n8m4JGIE3EeUttN9HuNSiBFwKVHaRvdZjEsgRsCVROn8us9hXDcxAq5NlM6r+wzGdRIj4MZE6Xy6339cFzECbk2UzqP73cd1ECPgzlaL0qPnPZ5r6X7vcXsTI+BsROluut953J7ECDg7Ubq97vcdtxcxAjYjSrfT/a7j9iBGwOZE6ea633Pc1sQI2I0o3Uz3O47bkhgBuxOl6+t+v3FbESOgjShdT/e7jduCGAHtROlq3e817tzECIghSg/X/U7jzkmMgDiidLnu9xl3LmIExBKlB+t+l3HnIEZAPFG6X/d7jLsrMQKmIUrP1P0O4+5CjIDpiNL/dT//uNsSI2BaonSh+9nH3YYYAdMTpf7nHndTYgQs4+hR6n7mcTchRsByjhyl7ucdd11iBCzrqFHqftZx1yFGwPKOGKXu5xx3FTECDuNoUep+xnEPI0bA4RwpSt3PN+4yYgQc1lGi1P1s4x5EjIDDO0KUup9r3EiMAP5n9Sh1P9O4e4kRwGDlKHU/z7gTMQK4xKpR6n6WcVViBHClFaPU/RzjxAjgmlaKUuKHP/GZbjMxAnaxUpTs/BMjYFeiZA+aGAEtRMnunRgBrUTJxAiIIUrHnhgBUUTpmBMjIJIoHWtiBEQTpWNMjIApiNLaEyNgKqK05sQImJIorTUxAqYmSmtMjIAliNLcEyNgKaI058QIWJIozTUxApYmSnNMjIBDEKXsiRFwKKKUOTECDkmUsiZGwKGJUsbECKBEqXtiBHAPURIjgBiiJEYAMURJjABiiJIYAcQQJTECiCFKYgQQQ5TECCCGKIkRQAxREiOAGKIkRgAxREmMAGKIkhgBxBAlMQKIIUpiBBBDlMQIIMbRoyRGAEGOGiUxAgh0tCiJEUCwo0RJjAAmsHqUxAhgIqtGSYwAJrRalMQIYGKrREmMABYwe5TECGAhs0ZJjAAWNFuUxAhgYbNESYwADiA9SmIEcCCpURIjgANKi5IYARxYSpTECID2KIkRAE/ripIYAXCfvaMkRgBcaq8oiREAV9o6SmIEwLVtFSUxAuDGzh0lMQLg1s4VJTEC4M7uGiUxAuBsbhslMQLg7G4aJTECYDPXjZIYAbC5q6IkRgDs5rIoiREAuxujJEYAtDlFSYwAaPd4iREAAAAAAADA2f0XElQVfXWHzA0AAAAASUVORK5CYII="/></defs></svg></button>',
      responsive: [
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 1201,
          settings: {
            slidesToShow: 3
          }
        }
      ]
    };

    // Sizes
    const clickSwatch = (evt) => {
      evt.preventDefault();

      if (evt.target.classList.contains('build-your-own-set__swatch--size')) {
        evt.target.closest('.build-your-own-set__swatches').querySelectorAll('.build-your-own-set__swatch--size').forEach((button) => {
          button.classList.remove('build-your-own-set__swatch--selected');
        });

        evt.target.classList.add('build-your-own-set__swatch--selected');
      }

      if (evt.target.classList.contains('color-swatch')) {
        evt.target.closest('.grid-product__colors').querySelectorAll('.color-swatch').forEach((button) => {
          button.classList.remove('build-your-own-set__swatch--selected');
        });

        evt.target.classList.add('build-your-own-set__swatch--selected');

        updateVariantImage(evt.target.closest('.build-your-own-set__product').querySelector('.build-your-own-set__product-image'), evt.target.dataset.variantImage);

        updateSwatchesAvailability(evt.target.closest('.build-your-own-set__product-information').querySelector('.build-your-own-set__swatches'));
      }

      resolveButton();
    };

    // Misc.
    const getCurrentVariants = () => {
      let topProductNode;
      let bottomProductNode;

      if (topsCarousel.childElementCount > 1) {
        topProductNode = topsCarousel.querySelector('.slick-center.build-your-own-set__product:not(.slick-cloned)');
      } else {
        topProductNode = topsCarousel.querySelector('.build-your-own-set__product');
      }

      if (bottomsCarousel.childElementCount > 1) {
        bottomProductNode = bottomsCarousel.querySelector('.slick-center.build-your-own-set__product:not(.slick-cloned)');
      } else {
        bottomProductNode = bottomsCarousel.querySelector('.build-your-own-set__product');
      }

      const topProductId = topProductNode ? topProductNode.dataset.id : null;
      const topProductSizePosition = topProductNode ? topProductNode.dataset.sizePosition : null;
      const topProductColorPosition = topProductNode ? topProductNode.dataset.colorPosition : null;

      const bottomProductId = bottomProductNode ? bottomProductNode.dataset.id : null;
      const bottomProductSizePosition = bottomProductNode ? bottomProductNode.dataset.sizePosition : null;
      const bottomProductColorPosition = bottomProductNode ? bottomProductNode.dataset.colorPosition : null;

      let topSize = null;
      let topColor = null;
      if (topProductNode) {
        topSize = topProductNode.querySelector('.build-your-own-set__swatch--size.build-your-own-set__swatch--selected')?.dataset.size || null;
        topColor = topProductNode.querySelector('.color-swatch.build-your-own-set__swatch--selected')?.dataset.color || null;
      }

      let bottomSize = null;
      let bottomColor = null;
      if (bottomProductNode) {
        bottomSize = bottomProductNode.querySelector('.build-your-own-set__swatch--size.build-your-own-set__swatch--selected')?.dataset.size || null;
        bottomColor = bottomProductNode.querySelector('.color-swatch.build-your-own-set__swatch--selected')?.dataset.color || null;
      }

      let topVariant = null;
      if (topProductSizePosition && !topProductColorPosition) { // Has only sizes
        topVariant = getVariantWithSize(topProductId, topProductSizePosition, topSize);
      } else if (!topProductSizePosition && topProductColorPosition) { // Has only colors
        topVariant = getVariantWithColor(topProductId, topProductColorPosition, topColor);
      } else if (topProductSizePosition && topProductColorPosition) { // Has both
        topVariant = getVariantWithColorAndSize(topProductId, topProductSizePosition, topSize, topProductColorPosition, topColor);
      }

      let bottomVariant = null;
      if (bottomProductSizePosition && !bottomProductColorPosition) { // Has only sizes
        bottomVariant = getVariantWithSize(bottomProductId, bottomProductSizePosition, bottomSize);
      } else if (!bottomProductSizePosition && bottomProductColorPosition) { // Has only colors
        bottomVariant = getVariantWithColor(bottomProductId, bottomProductColorPosition, bottomColor);
      } else if (bottomProductSizePosition && bottomProductColorPosition) { // Has both
        bottomVariant = getVariantWithColorAndSize(bottomProductId, bottomProductSizePosition, bottomSize, bottomProductColorPosition, bottomColor);
      }

      if (topVariant) {
        topProductNode.closest('.build-your-own-set__product')?.querySelectorAll('.build-your-own-set__link').forEach((link) => {
          link.href = link.href.match(/\?variant=[0-9]+/) ? link.href.replace(/\?variant=[0-9]+/, `?variant=${topVariant.id}`) : `${link.href}?variant=${topVariant.id}`;
        });
      }

      if (bottomVariant) {
        bottomProductNode.closest('.build-your-own-set__product')?.querySelectorAll('.build-your-own-set__link').forEach((link) => {
          link.href = link.href.match(/\?variant=[0-9]+/) ? link.href.replace(/\?variant=[0-9]+/, `?variant=${bottomVariant.id}`) : `${link.href}?variant=${bottomVariant.id}`;
        });
      }

      return {
        'topVariant': topVariant?.available ? topVariant : null,
        'bottomVariant': bottomVariant?.available ? bottomVariant : null,
      };
    };

    // Add to cart
    const addToCart = (evt) => {
      resolveButton();

      if (addToCartButton.disabled) {
        return;
      }

      addToCartButton.disabled = true;

      const variants = getCurrentVariants();

      const errorHolder = addToCartButton.parentElement.querySelector('.build-your-own-set__atc-error');

      if (variants.bottomVariant && variants.topVariant) {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: `id=${variants.bottomVariant.id}`,
          dataType: 'json'
        }).then(() => {
          errorHolder.textContent = '';

          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: `id=${variants.topVariant.id}`,
            dataType: 'json'
          }).then(() => {
            theme.cart.getCart().then((cart) => {
              drawerCart.buildCart(cart, true);

              addToCartButton.disabled = false;
            });
          }, (response) => {
            errorHolder.textContent = response.responseJSON.description;

            addToCartButton.disabled = false;
          });
        }, (response) => {
          errorHolder.textContent = response.responseJSON.description;

          addToCartButton.disabled = false;
        });
      } else {
        const variantToAdd = variants.topVariant ? variants.topVariant : variants.bottomVariant ? variants.bottomVariant : null;

        if (!variantToAdd) {
          return;
        }

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: `id=${variantToAdd.id}`,
          dataType: 'json'
        }).then(() => {
          theme.cart.getCart().then((cart) => {
            drawerCart.buildCart(cart, true);

            addToCartButton.disabled = false;
          });
        }, (response) => {
          errorHolder.textContent = response.responseJSON.description;

          addToCartButton.disabled = false;
        });
      }
    };

    const getVariantWithSize = (productId, productSizePosition, size) => {
      if (!productId) {
        return null;
      }

      if (window.byos.variants[productId].length === 1) {
        return window.byos.variants[productId][0];
      }

      return window.byos.variants[productId].filter((variant) => {
        return variant[`option${productSizePosition}`] === size;
      })[0] || null;

      // return window.byos.variants[productId].filter((variant) => {
      //   return variant['merged_options'].indexOf(`size:${size}`) !== -1;
      // })[0] || null;
    };

    const getVariantWithColor = (productId, productColorPosition, color) => {
      if (!productId) {
        return null;
      }

      if (window.byos.variants[productId].length === 1) {
        return window.byos.variants[productId][0];
      }

      return window.byos.variants[productId].filter((variant) => {
        return variant[`option${productColorPosition}`] === color;
      })[0] || null;

      // return window.byos.variants[productId].filter((variant) => {
      //   return variant['merged_options'].indexOf(`color:${color}`) !== -1;
      // })[0] || null;
    };

    const getVariantWithColorAndSize = (productId, productSizePosition, size, productColorPosition, color) => {
      if (!productId) {
        return null;
      }

      if (window.byos.variants[productId].length === 1) {
        return window.byos.variants[productId][0];
      }

      return window.byos.variants[productId].filter((variant) => {
        return variant[`option${productSizePosition}`] === size && variant[`option${productColorPosition}`] === color;
      })[0] || null;

      // return window.byos.variants[productId].filter((variant) => {
      //   return variant['merged_options'].indexOf(`color:${color}`) !== -1;
      // })[0] || null;
    };

    const updateSwatchesAvailability = (holder) => {
      if (!holder) {
        return;
      }

      // const firstAvailableSet = [];

      const colorsHolder = holder.closest('.build-your-own-set__product-information').querySelector('.grid-product__colors');

      holder.querySelectorAll('.build-your-own-set__swatch').forEach((button) => {
        const productNode = button.closest('.build-your-own-set__product');
        const productId = productNode.dataset.id;
        const productSizePosition = productNode.dataset.sizePosition;
        const productColorPosition = productNode.dataset.colorPosition;
        const size = button.dataset.size || null;
        const color = colorsHolder?.querySelector('.build-your-own-set__swatch--selected').dataset.color || null;

        let variant = null;
        if (size && !color) { // Has only sizes
          variant = getVariantWithSize(productId, productSizePosition, size);
        } else if (!size && color) { // Has only colors
          variant = getVariantWithColor(productId, productColorPosition, color);
        } else if (size && color) {
          variant = getVariantWithColorAndSize(productId, productSizePosition, size, productColorPosition, color);
        }

        if (variant && variant.available) {
          button.disabled = false;

          // if (firstAvailableSet.indexOf(productId) === -1) {
          //   button.classList.add('build-your-own-set__swatch--selected');

          //   firstAvailableSet.push(productId);
          // }
        } else {
          button.disabled = true;

          button.classList.remove('build-your-own-set__swatch--selected');
        }
      });
    }

    const updateVariantImage = (imageElement, newImage) => {
      imageElement.src = newImage;
    }

    const resolveSwatchesAvailability = () => {
      document.querySelectorAll('.build-your-own-set__swatches:not(.build-your-own-set__swatches--initialized)').forEach((swatchesHolder) => {
        updateSwatchesAvailability(swatchesHolder);

        swatchesHolder.classList.add('build-your-own-set__swatches--initialized');
      });
    };

    const resolveButton = () => {
      const variants = getCurrentVariants();

      if (variants.topVariant || variants.bottomVariant) {
        addToCartButton.disabled = false;

        addToCartButton.textContent = theme.strings.addToCart;
      } else {
        addToCartButton.disabled = true;

        addToCartButton.textContent = 'Select a color / size';
      }
    };

    const clickColorSwatch = (evt) => {
      evt.preventDefault();
    };

    document.querySelectorAll('.build-your-own-set__product .build-your-own-set__swatch').forEach((button) => {
      button.addEventListener('click', clickSwatch);
    });

    document.querySelectorAll('.build-your-own-set__product .grid-product__colors').forEach((button) => {
      button.addEventListener('click', clickSwatch);
    });

    document.querySelectorAll('.build-your-own-set__product-information .color-swatch').forEach((swatch) => {
      swatch.addEventListener('click', clickColorSwatch);
    });

    addToCartButton.addEventListener('click', addToCart);

    resolveSwatchesAvailability();

    if (topsCarousel.childElementCount > 1) {
      $(topsCarousel).on('afterChange', resolveButton);

      if (topsCarousel.childElementCount < 4) {
        options.slidesToShow = 1;
      } else {
        options.slidesToShow = 5;
      }

      $(topsCarousel).slick(options);
    }

    if (bottomsCarousel.childElementCount > 1) {
      $(bottomsCarousel).on('afterChange', resolveButton);
      $(bottomsCarousel).on('init', resolveButton);

      if (bottomsCarousel.childElementCount < 4) {
        options.slidesToShow = 1;
      } else {
        options.slidesToShow = 5;
      }

      $(bottomsCarousel).slick(options);
    }
  };

  window.init7Q81BuildYourOwnSet();

  // Grid items
  (() => {
    const controlClass = 'handled-7q81';

    window.init7Q81Collection = (gridItemSelector = `.grid__item.grid-product .color-swatch:not(.${controlClass})`) => {
      const updateTag = (gridItem, isAvailable) => {
        const titleHolder = gridItem.querySelector('.grid-product__title');
        const originalTag = gridItem.dataset.originalTag || null;
        const newTag = document.createElement('div');
        newTag.classList.add('grid-product__tag', 'grid-product__tag--sold-out');

        titleHolder.querySelector('.grid-product__tag')?.remove();

        if (!isAvailable) {
          newTag.textContent = 'Notify Me'
        } else if (originalTag) {
          newTag.textContent = originalTag;
        }

        if (newTag.textContent) {
          titleHolder.appendChild(newTag);
        }
      };

      const handleSwatchClick = (evt) => {
        evt.preventDefault();

        const target = evt.target.closest('.color-swatch') || evt.target;
        const gridItem = target.closest('.grid__item');
        const productId = gridItem.dataset.id;
        const isAvailable = target.dataset.available === 'true' ? true : false;
        const variantId = target.dataset.variantId;
        const variantImage = target.dataset.variantImage;
        const variantSecondaryImage = target.dataset.variantSecondaryImage;
        const mainImage = target.closest('.grid-product__content').querySelector('.grid-product__image');
        const secondaryImage = target.closest('.grid-product__content').querySelector('.grid-product__secondary-image');
        const selectedElementIndex = Array.from(target.parentNode.children).indexOf(target) + 1;

        // Notify me tag
        updateTag(gridItem, isAvailable);

        // Image
        if (mainImage) {
          // target.closest('.grid-product__content').querySelectorAll('a:not(.color-swatch)').forEach((a) => {
          //   a.href = target.href;
          // });

          target.closest('.grid-product__content').querySelectorAll('.grid-product__color-image').forEach((image) => {
            if (image.classList.contains(`grid-product__color-image--${variantId}`)) {
              image.classList.add('is-active--final');
              if (!image.style.backgroundImage) {
                image.style.backgroundImage = `url(${variantImage})`;
              }
            } else {
              image.classList.remove('is-active--final');
            }
          });
        }

        if (secondaryImage) {
          secondaryImage.dataset.bgset = '';
          secondaryImage.style.backgroundImage = `url(${variantSecondaryImage})`;
        }

        const modal = document.getElementById(`QuickShopModal-${productId}`);

        if (modal && selectedElementIndex) {
          modal.dataset.selectedVariantIndex = selectedElementIndex;

          const input = modal.querySelector(`.variant-input-wrap[name="Color"] .variant-input:nth-child(${selectedElementIndex}) label`);

          if (input) {
            input.click();
          }
        }
      };

      document.querySelectorAll(gridItemSelector).forEach((swatch, index) => {
        // swatch.addEventListener('mouseenter', handleSwatchClick);
        swatch.classList.add(controlClass);
        swatch.addEventListener('click', handleSwatchClick);

        let lastProduct = null;
        const gridItem = swatch.closest('.grid__item');
        if (gridItem.dataset.originalTag === undefined) {
          gridItem.dataset.originalTag = gridItem.querySelector('.grid-product__tag')?.textContent || '';

          // Click the first swatch
          if (gridItem.dataset.id !== lastProduct) {
            lastProduct = gridItem.dataset.id;
            swatch.click();
          }
        }
      });
    };

    // Activate it for homepage featured collections
    if (document.body.classList.contains('template-index')) {
      window.init7Q81Collection();
    }
  })();

  // Collection
  (() => {
    if (!document.body.classList.contains('template-collection')) {
      return;
    }

    /*
    const scrollToPreviousPosition = () => {
      if (localStorage.getItem('lastKnownScrollPosition')) {
        window.scrollTo({
          top: localStorage.getItem('lastKnownScrollPosition'),
          left: 0,
        });
      }
    };

    // Safari hack, as always... thanks Apple.
    window.addEventListener('pageshow', (evt) => {
      if (evt.persisted) {
        scrollToPreviousPosition();
      };
    }, false);

    scrollToPreviousPosition();
    */

    // Init collection
    window.init7Q81Collection();

    document.documentElement.addEventListener('click', (evt) => {
      if (!evt.target.closest('.boost-pfs-filter-option-item.selected')) {
        return;
      }

      const option = evt.target.closest('.boost-pfs-filter-option');

      if (option) {
        const button = option.querySelector('.boost-pfs-filter-button.boost-pfs-filter-option-title-heading');

        if (button) {
          // Close and trigger filters
          button.click();
          // Open again
          button.click();
        }
      }
    });

    const sortByReplacementButton = document.querySelector('#sortBy__replacement > button');

    if (sortByReplacementButton) {
      const handleSortByReplacementButtonClick = (evt) => {
        evt.target.classList.toggle('sortBy__replacement-button--active');
      };

      sortByReplacementButton.addEventListener('click', handleSortByReplacementButtonClick);
    }

    // Save scroll position
    /*
    let lastKnownScrollPosition = 0;
    let ticking = false;

    function doScroll(scrollPos) {
      localStorage.setItem('lastKnownScrollPosition', scrollPos);
    }

    document.addEventListener('scroll', function (e) {
      lastKnownScrollPosition = window.scrollY;

      if (!ticking) {
        window.requestAnimationFrame(function () {
          doScroll(lastKnownScrollPosition);
          ticking = false;
        });

        ticking = true;
      }
    });
    */
  })();

  // PDP & Cart
  (() => {
    if (!document.body.classList.contains('template-product') && !document.body.classList.contains('template-cart')) {
      return;
    }

    // Collapsible recommendations
    // if (document.documentElement.clientWidth < 769) {
    const handleRecommedationsTitleClick = (evt) => {
      const target = evt.target.closest('.section-header') || evt.target;

      if (target) {
        target.classList.toggle('is-open');
      }

      const content = evt.target.closest('.shopify-section').querySelector('.recommendations-collapsible-content');

      if (content) {
        content.classList.toggle('is-open');
      }

      if (content.classList.contains('is-open')) {
        $(content).slideDown();
      } else {
        $(content).slideUp();
      }
    };

    const recommendationsTitle = document.querySelector('#shopify-section-product-recommendations .section-header');
    if (recommendationsTitle) {
      recommendationsTitle.addEventListener('click', handleRecommedationsTitleClick);
    }

    const mixItTitle = document.querySelector('#shopify-section-product-mix-it .section-header');
    if (mixItTitle) {
      mixItTitle.addEventListener('click', handleRecommedationsTitleClick);
    }
    // }
  })();

  // PDP
  (() => {
    if (!document.body.classList.contains('template-product')) {
      return;
    }

    // const handleTabClick = (evt) => {
    //   evt.preventDefault();

    //   document.querySelectorAll('.product-single__tab-heading').forEach((button) => {
    //     button.classList.remove('product-single__tab-heading--active');
    //   });

    //   evt.target.classList.add('product-single__tab-heading--active');

    //   // document.querySelectorAll('.product-single__tab').forEach((button) => {
    //   //   button.classList.remove('product-single__tab--active');
    //   // });

    //   document.querySelector(`.product-single__tab[data-index="${evt.target.dataset.index}"]`).classList.add('product-single__tab--active');
    // };

    // document.querySelectorAll('.product-single__tab-heading').forEach((button) => {
    //   button.addEventListener('click', handleTabClick);
    // });
    const handleTabClick = (evt) => {
      evt.preventDefault(); // Prevent the default link behavior
    
      // Toggle the active class on the clicked tab heading
      evt.target.classList.toggle('product-single__tab-heading--active');
    
      // Find the corresponding tab content and toggle its active class
      const tabContent = document.querySelector(`.product-single__tab[data-index="${evt.target.dataset.index}"]`);
      if (tabContent) {
        tabContent.classList.toggle('product-single__tab--active');
      }
    };
    
    document.querySelectorAll('.product-single__tab-heading').forEach((button) => {
      button.addEventListener('click', handleTabClick);
    });
    // Size guide
    new theme.Drawers('SizeGuideDrawer', 'size-guide');

    // Change recommendations & BYOS colors on main swatch change
    const handleMainSwatchClick = (evt) => {
      const parent = evt.target.closest('.variant-input');

      if (!parent) {
        return;
      }

      const input = parent.querySelector('input');

      if (!input) {
        return;
      }

      const basicShade = input.dataset.basicShade;
      const color = input.value;

      // document.querySelectorAll(`.product-recommendations input[value="${color}"] + label`).forEach((label) => {
      //   if (input.value === color || (basicShade && input.dataset.basicShade === basicShade)) {
      //     label.click();
      //   }
      // });

      // Desktop related
      document.querySelectorAll('.product-recommendations:not(.product-recommendations--mix-it):not(.product-recommendations--cart) .grid__item:not(.grid__item--alt).grid-product').forEach((gridItem) => {
        let found = false;

        gridItem.querySelectorAll(`input[value="${color}"] + label`).forEach((label) => {
          if (found) {
            return;
          }

          if (input.value === color || (basicShade && input.dataset.basicShade === basicShade)) {
            found = true;

            label.click();
          }
        });

        if (!found) {
          gridItem.hidden = true;
        } else {
          gridItem.hidden = false;
        }
      });

      // Mobile related
      document.querySelectorAll('.product-recommendations:not(.product-recommendations--mix-it):not(.product-recommendations--cart) .grid__item--alt.grid-product').forEach((gridItem) => {
        let found = false;

        const select = gridItem.querySelector('.grid-product-alt__color-select select');

        if (select) {
          for (let i = 0; i < select.options.length; i += 1) {
            if (select.options[i].textContent === color || (basicShade && select.options[i].dataset.basicShade === basicShade)) {
              found = true;

              select.selectedIndex = i;
              select.dispatchEvent(new Event('change'));
              break;
            }
          }
        }

        if (!found) {
          gridItem.hidden = true;
        } else {
          gridItem.hidden = false;
        }
      });

      // BYOS related
      let slickRepositionedTop = false;
      let slickRepositionedBottom = false;

      document.querySelectorAll('.build-your-own-set__product button.color-swatch').forEach((button) => {
        if (button.dataset.color === color || (basicShade && button.dataset.basicShade === basicShade)) {
          button.click();

          const slider = button.closest('.slick-slider');
          const product = button.closest('.build-your-own-set__product');
          const slidePosition = product.dataset.slickIndex;

          if (!slickRepositionedTop && slidePosition > 0 && slider.classList.contains('build-your-own-set__tops-wrapper')) {
            $(slider).slick('goTo', product.dataset.slickIndex);

            slickRepositionedTop = true;
          }

          if (!slickRepositionedBottom && slidePosition > 0 && slider.classList.contains('build-your-own-set__bottoms-wrapper')) {
            $(slider).slick('goTo', product.dataset.slickIndex);

            slickRepositionedBottom = true;
          }
        }
      });
    };

    document.querySelectorAll('.variant-input--main .variant__button-label.color-swatch').forEach((swatch, index) => {
      swatch.addEventListener('click', handleMainSwatchClick);
    });

    const selectedColorSwatchLabel = document.querySelector('.variant-input--main input[name="Color"]:checked + label');

    if (selectedColorSwatchLabel) {
      selectedColorSwatchLabel.click();
    }
  })();

  // Recommended products (init)
  (() => {
    if (!document.body.classList.contains('template-product') && !document.body.classList.contains('template-cart')) {
      return;
    }

    window.init7Q81GridProduct = (productId) => {
      const handleSwatchClick = (evt) => {
        const quickShopModal = document.querySelector(`#QuickShopModal-${productId}`);

        if (!quickShopModal) {
          return;
        }

        const target = evt.target.closest('.variant-input') || evt.target;
        const label = target.querySelector('label');

        if (!label) {
          return;
        }

        const quickShopModalLabel = quickShopModal.querySelector(`label[for="${label.getAttribute('for').replace(/-[0-9]+$/, '')}"]`);

        if (!quickShopModalLabel) {
          return;
        }

        quickShopModalLabel.click();

        const gridItem = evt.target.closest('.grid__item.grid-product');

        if (!gridItem) {
          return;
        }

        const quickShopModalPrice = quickShopModalLabel.querySelector('.product__price');

        if (quickShopModalPrice) {
          const price = gridItem.querySelector('.grid-product__price');

          if (price) {
            price.textContent = quickShopModalPrice.textContent;
          }
        }

        const addToCartButton = gridItem.querySelector('.grid-product__add-to-cart');

        if (!addToCartButton) {
          return;
        }

        const quickShopModalAddToCartButton = quickShopModal.querySelector('.btn.add-to-cart');

        if (!quickShopModalAddToCartButton) {
          return;
        }

        addToCartButton.textContent = quickShopModalAddToCartButton.disabled ? 'Sold Out' : quickShopModalAddToCartButton.textContent;
        addToCartButton.disabled = quickShopModalAddToCartButton.disabled;

        const selectedElementIndex = Array.from(target.parentNode.children).indexOf(target) + 1;

        // Add selected index to modal (preserve color)
        if (selectedElementIndex) {
          quickShopModal.dataset.selectedVariantIndex = selectedElementIndex;

          const input = quickShopModal.querySelector(`.variant-input-wrap[name="Color"] .variant-input:nth-child(${selectedElementIndex}) label`);

          if (input) {
            input.click();
          }
        }
      };

      const handleSwatchChange = (evt) => {
        if (!evt.target.options[evt.target.selectedIndex]) {
          return;
        }

        if (evt.target.options[evt.target.selectedIndex].dataset.redirectTo) {
          window.location = evt.target.options[evt.target.selectedIndex].dataset.redirectTo;
          return;
        }

        const featuredMedia = evt.target.options[evt.target.selectedIndex].dataset.featuredMedia;

        if (featuredMedia) {
          evt.target.dataset.featuredMedia = featuredMedia;
        }

        const quickShopModal = document.querySelector(`#QuickShopModal-${productId}`);

        if (!quickShopModal) {
          return;
        }

        const quickShopModalLabel = quickShopModal.querySelector(`label[for="${evt.target.value}"]`);

        if (!quickShopModalLabel) {
          return;
        }

        quickShopModalLabel.click();

        const gridItem = evt.target.closest('.grid__item.grid-product');

        if (!gridItem) {
          return;
        }

        const quickShopModalPrice = quickShopModalLabel.querySelector('.product__price');

        if (quickShopModalPrice) {
          const price = gridItem.querySelector('.grid-product__price');

          if (price) {
            price.textContent = quickShopModalPrice.textContent;
          }
        }

        const addToCartButton = gridItem.querySelector('.grid-product__add-to-cart');

        if (!addToCartButton) {
          return;
        }

        const quickShopModalAddToCartButton = quickShopModal.querySelector('.btn.add-to-cart');

        if (!quickShopModalAddToCartButton) {
          return;
        }

        addToCartButton.textContent = quickShopModalAddToCartButton.disabled ? 'Sold Out' : quickShopModalAddToCartButton.textContent;
        addToCartButton.disabled = quickShopModalAddToCartButton.disabled;
      };

      const addToCart = (evt) => {
        const quickShopModal = document.querySelector(`#QuickShopModal-${productId}`);

        if (!quickShopModal) {
          return;
        }
        const quickShopModalAddToCartButton = quickShopModal.querySelector('.btn.add-to-cart');

        if (!quickShopModalAddToCartButton) {
          return;
        }

        quickShopModalAddToCartButton.click();
      };

      const changeImage = (evt) => {
        const image = evt.target.closest('.grid__item.grid-product').querySelector('.grid-product__image');
        const secondaryImage = evt.target.closest('.grid__item.grid-product').querySelector('.grid-product__secondary-image');

        if (image) {
          const imageSrc = evt.target.dataset.featuredMedia;

          if (imageSrc) {
            image.src = imageSrc;
          }
        }

        if (secondaryImage) {
          const secondaryImageSrc = evt.target.dataset.featuredSecondaryMedia;

          if (secondaryImageSrc) {
            secondaryImage.dataset.bgset = '';
            secondaryImage.style.backgroundImage = `url(${secondaryImageSrc})`;
          }
        }
      };

      const controlClass = 'handled-7q81';

      let gridItem = document.querySelector(`.grid__item:not(.grid__item--alt).grid-product[data-id="${productId}"]:not(.${controlClass})`);

      // Ignore Mix it.
      if (gridItem && !gridItem.closest('.product-recommendations--mobile.product-recommendations--mix-it')) {
        gridItem.classList.add(controlClass);

        const variantsHolder = gridItem.querySelector('.grid-product__variant-holders');
        const addToCartButton = gridItem.querySelector('.grid-product__add-to-cart');
        const quickShopModal = document.querySelector(`#QuickShopModal-${productId}`);

        if (!productId || !variantsHolder || !addToCartButton || !quickShopModal) {
          return;
        }

        colors = quickShopModal.querySelector('fieldset[name="Color"]');
        sizes = quickShopModal.querySelector('fieldset[name="Size"]');

        if (colors) {
          const newColors = variantsHolder.appendChild(colors.cloneNode(true));

          if (newColors && colors.childElementCount < 2) {
            newColors.style.visibility = 'hidden';
          }
        }

        if (sizes) {
          variantsHolder.appendChild(sizes.cloneNode(true));
        }

        variantsHolder.querySelectorAll('input').forEach((input, index) => {
          const newId = `${input.id}-${index + 1}`;
          const label = document.querySelector(`label[for="${input.id}"]`);

          if (label) {
            label.setAttribute('for', newId);
            label.classList.remove('disabled');
            label.addEventListener('click', handleSwatchClick);

            if (label.classList.contains('color-swatch')) {
              label.addEventListener('click', changeImage);
            };
          }

          input.id = newId;
          input.name = `${input.name}-${productId}`;
          input.classList.remove('disabled');

          // if (input.checked) {
          //   label.click();

          //   // Somehow the line above will make a scroll jump
          //   window.scrollTo(0, 0);
          // }
        });

        addToCartButton.addEventListener('click', addToCart);
      }

      // Alt (mobile)
      gridItem = document.querySelector(`.grid__item.grid__item--alt.grid-product[data-id="${productId}"]:not(.${controlClass}):not(.grid__item--alt-cart)`);

      // Ignore Mix it.
      if (gridItem && !gridItem.closest('.product-recommendations--mobile.product-recommendations--mix-it')) {
        gridItem.classList.add(controlClass);

        const colorsHolder = gridItem.querySelector('.grid-product-alt__color-select select');
        const sizesHolder = gridItem.querySelector('.grid-product-alt__size-select select');
        const addToCartButton = gridItem.querySelector('.grid-product__add-to-cart');
        const quickShopModal = document.querySelector(`#QuickShopModal-${productId}`);

        if (!productId || !colorsHolder || !sizesHolder || !addToCartButton || !quickShopModal) {
          return;
        }

        colors = quickShopModal.querySelector('fieldset[name="Color"]');
        sizes = quickShopModal.querySelector('fieldset[name="Size"]');

        if (colors) {
          colors.querySelectorAll('input').forEach((input) => {
            const option = document.createElement('option');
            option.value = input.id;
            option.textContent = input.value;

            const label = input.nextElementSibling;

            if (label && label.dataset.featuredMedia) {
              option.dataset.featuredMedia = label.dataset.featuredMedia;
            }

            if (label && label.dataset.featuredSecondaryMedia) {
              option.dataset.featuredSecondaryMedia = label.dataset.featuredSecondaryMedia;
            }

            if (input.checked) {
              option.selected = true;
              colorsHolder.dataset.featuredMedia = option.dataset.featuredMedia;
            }

            colorsHolder.appendChild(option);
          });

          colors.querySelectorAll('.color-swatch--link').forEach((link) => {
            const option = document.createElement('option');
            option.value = '';
            option.textContent = link.textContent;
            option.dataset.redirectTo = link.closest('.variant__button-link').href;

            colorsHolder.appendChild(option);
          });

          colorsHolder.addEventListener('change', handleSwatchChange);
          colorsHolder.addEventListener('change', changeImage);

          colorsHolder.addEventListener('updateImage', changeImage);
          colorsHolder.dispatchEvent(new CustomEvent('updateImage'));
        } else {
          colorsHolder.remove();
        }

        if (sizes) {
          sizes.querySelectorAll('input').forEach((input) => {
            const option = document.createElement('option');
            option.value = input.id;
            option.textContent = input.value;

            if (input.checked) {
              option.selected = true;
            }

            sizesHolder.appendChild(option);
          });

          sizesHolder.addEventListener('change', handleSwatchChange);
          // sizesHolder.dispatchEvent(new Event('change'));
        } else {
          sizesHolder.remove();
        }

        addToCartButton.addEventListener('click', addToCart);
      }

      // This will update related variants based on the selected main color.
      // quickShopModalsCount === 0 means is the last loaded modal.
      quickShopModalsCount -= 1;

      // PDP
      if (quickShopModalsCount === 0 && document.body.classList.contains('template-product')) {
        const selectedColorSwatch = document.querySelector('.variant-input--main input[name="Color"]:checked');

        if (selectedColorSwatch) {
          selectedColorSwatch.nextElementSibling.click();
        }

        // Click selected color for "Mix It" section
        // Desktop
        document.querySelectorAll('.product-recommendations--mix-it.product-recommendations--desktop .grid-product--mix-it').forEach((product) => {
          const selectedColor = product.dataset.selectedColor;

          if (!selectedColor) {
            return;
          }

          const swatch = product.querySelector(`input[value="${selectedColor}"] + label`);

          if (!swatch) {
            return;
          }

          swatch.click();
        });

        // Init "Mix It" mobile swatches
        window.init7Q81Collection(`.product-recommendations--mobile .grid__item.grid-product .color-swatch:not(.${controlClass})`);

        // Mobile
        document.querySelectorAll('.product-recommendations--mobile .grid__item.grid-product--mix-it').forEach((product) => {
          const selectedColor = product.dataset.selectedColor;

          if (!selectedColor) {
            return;
          }

          const swatch = product.querySelector(`.color-swatch[data-color="${selectedColor}"]`);

          if (!swatch) {
            return;
          }

          swatch.click();
        });
        // Cart
      } else if (quickShopModalsCount === 0 && document.body.classList.contains('template-cart')) {
        const relatedProductMeta = document.querySelector('.grid__item--has-related .cart__product-meta');

        if (!relatedProductMeta) {
          return;
        }

        const color = relatedProductMeta.dataset.color;

        if (!color) {
          return;
        }

        // Desktop
        document.querySelectorAll(`.product-recommendations--desktop .grid-product input[value="${color}"] + label`).forEach((label) => {
          label.click();
        });

        // Mobile
        document.querySelectorAll(`.product-recommendations--mobile .grid-product`).forEach((gridItem) => {
          const select = gridItem.querySelector('.grid-product-alt__color-select select');

          if (select) {
            for (let i = 0; i < select.options.length; i += 1) {
              if (select.options[i].textContent === color) {
                select.selectedIndex = i;
                select.dispatchEvent(new Event('change'));
                break;
              }
            }
          }
        });
      }
    }

    let quickShopModalsCount = 0;

    let interval = setInterval(() => {
      if (document.querySelector('.modal--quick-shop .product-section')) {
        clearInterval(interval);
        interval = null;

        document.querySelectorAll('.modal--quick-shop .product-section').forEach((modal) => {
          quickShopModalsCount += 1;

          const product = new theme.Product(modal);
          product.openModalProduct();
        });
      }
    }, 100);
  })();

  // Cart
  (() => {
    if (!document.body.classList.contains('template-cart')) {
      return;
    }

    document.querySelectorAll('.js-qty__wrapper').forEach((holder) => {
      new theme.QtySelector($(holder), {
        namespace: '.cart-page'
      });
    });

    const handleQtySelectorButtonClick = (evt) => {
      const input = evt.target.closest('.js-qty__wrapper').querySelector('.js-qty__num');
      const button = evt.target.closest('.js-qty__adjust');

      if (!input || !button) {
        return;
      }

      button.disabled = true;

      input.form.submit();
    };

    document.querySelectorAll('#shopify-section-cart-template .js-qty__adjust').forEach((button) => {
      button.addEventListener('click', handleQtySelectorButtonClick);
    });
  })();

  // Pages
  (() => {
    if (!document.body.classList.contains('template-page')) {
      return;
    }

    // Collapsibles (FAQ)
    const handleCollapsibleTitleClick = (evt) => {
      const target = evt.target.closest('.pages__collapsibles-title') || evt.target;

      target.classList.toggle('pages__collapsibles-title--active');
    };

    document.querySelectorAll('.pages__collapsibles-title').forEach((title) => {
      title.addEventListener('click', handleCollapsibleTitleClick);
    });
  })();

  // Drawer related
  (() => {
    window.init7Q81CartRelatedProducts = () => {
      const drawerCart = new theme.CartDrawer(true);

      const handleSwatchChange = (evt) => {
        if (!evt.target.options[evt.target.selectedIndex]) {
          return;
        }

        if (evt.target.options[evt.target.selectedIndex].dataset.redirectTo) {
          window.location = evt.target.options[evt.target.selectedIndex].dataset.redirectTo;
          return;
        }

        const featuredMedia = evt.target.options[evt.target.selectedIndex].dataset.featuredMedia;

        if (featuredMedia) {
          evt.target.dataset.featuredMedia = featuredMedia;
        }

        const gridItem = evt.target.closest('.grid__item.grid-product');

        if (!gridItem) {
          return;
        }

        const colorsHolder = gridItem.querySelector('.grid-product-alt__color-select select');
        const sizesHolder = gridItem.querySelector('.grid-product-alt__size-select select');
        const addToCartButton = gridItem.querySelector('.grid-product__add-to-cart');

        if (!addToCartButton) {
          return;
        }

        const productId = gridItem.dataset.id;

        if (!productId || !window.drawerRelated[productId]) {
          return;
        }

        const colorPosition = gridItem.dataset.colorPosition;
        const sizePosition = gridItem.dataset.sizePosition;

        let variantId;
        let available;
        let buttonText;

        if (colorsHolder && colorPosition && sizesHolder && sizePosition) {
          window.drawerRelated[productId].variants.forEach((variant) => {
            if (variant[colorPosition] === colorsHolder.value && variant[sizePosition] === sizesHolder.value) {
              variantId = variant.id;
              available = variant.available;
              buttonText = available ? '+ Add to Cart' : 'Sold Out';
            }
          });
        } else if (colorsHolder && colorPosition) {
          window.drawerRelated[productId].variants.forEach((variant) => {
            if (variant[colorPosition] === colorsHolder.value) {
              variantId = variant.id;
              available = variant.available;
              buttonText = available ? '+ Add to Cart' : 'Sold Out';
            }
          });
        } else if (sizesHolder && sizePosition) {
          window.drawerRelated[productId].variants.forEach((variant) => {
            if (variant[sizePosition] === sizesHolder.value) {
              variantId = variant.id;
              available = variant.available;
              buttonText = available ? '+ Add to Cart' : 'Sold Out';
            }
          });
        }

        addToCartButton.dataset.variantId = variantId;
        addToCartButton.textContent = buttonText;
        addToCartButton.disabled = available ? false : true;
      };

      const changeImage = (evt) => {
        const image = evt.target.closest('.grid__item.grid-product').querySelector('.grid-product__image');

        if (!image) {
          return;
        }

        const imageSrc = evt.target.dataset.featuredMedia;

        if (!imageSrc) {
          return;
        }

        image.src = imageSrc;
      };

      const addToCart = (evt) => {
        evt.preventDefault();

        const variantId = evt.target.dataset.variantId;

        if (!variantId) {
          return;
        }

        const gridItem = evt.target.closest('.grid__item--alt-cart');

        if (!gridItem) {
          return;
        }

        const recommendationsHolder = evt.target.closest('#DrawerCartRecommendations');

        if (!recommendationsHolder) {
          return;
        }

        evt.target.disabled = true;

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: `id=${variantId}`,
          dataType: 'json'
        }).then(() => {
          // errorHolder.textContent = '';

          theme.cart.getCart().then((cart) => {
            drawerCart.buildCart(cart, true);

            gridItem.remove();

            if (!recommendationsHolder.querySelectorAll('.grid__item--alt-cart').length) {
              while (recommendationsHolder.firstChild) {
                recommendationsHolder.removeChild(recommendationsHolder.lastChild);
              }
            }

            evt.target.disabled = false;
          });
        }, (response) => {
          // errorHolder.textContent = response.responseJSON.description;

          evt.target.disabled = false;
        });
      };

      const controlClass = 'handled-7q81';

      document.querySelectorAll(`.grid__item.grid__item--alt-cart:not(.${controlClass})`).forEach((gridItem) => {
        gridItem.classList.add(controlClass);

        const productId = gridItem.dataset.id;

        if (!productId || !window.drawerRelated[productId]) {
          return;
        }

        let colorPosition = null;
        let sizePosition = null;

        window.drawerRelated[productId].options.forEach((option, index) => {
          const optionLowerCase = option.toLowerCase();

          if (!sizePosition && optionLowerCase === 'size') {
            sizePosition = `option${index + 1}`;
          } else if (!colorPosition && (optionLowerCase === 'color' || optionLowerCase === 'colour')) {
            colorPosition = `option${index + 1}`;
          }
        });

        gridItem.dataset.colorPosition = colorPosition || '';
        gridItem.dataset.sizePosition = sizePosition || '';

        const colorsHolder = gridItem.querySelector('.grid-product-alt__color-select select');
        const sizesHolder = gridItem.querySelector('.grid-product-alt__size-select select');
        const addToCartButton = gridItem.querySelector('.grid-product__add-to-cart');

        if (!colorsHolder || !sizesHolder || !addToCartButton) {
          return;
        }

        let colors = {};
        let sizes = [];
        let foundFirstAvailableVariant = false;
        let firstAvailableVariantColor = null;
        let firstAvailableVariantSize = null;

        window.drawerRelated[productId].variants.forEach((variant) => {
          if (variant[colorPosition] && !colors[variant[colorPosition]]) {
            colors[variant[colorPosition]] = { value: variant[colorPosition], featuredMedia: variant.featured_image };
          }

          if (variant[sizePosition] && sizes.indexOf(variant[sizePosition]) === -1) {
            sizes.push(variant[sizePosition]);
          }

          if (!foundFirstAvailableVariant && variant.available) {
            firstAvailableVariantColor = variant[colorPosition] || null;
            firstAvailableVariantSize = variant[sizePosition] || null;
            foundFirstAvailableVariant = true;
          }
        });

        if (Object.keys(colors).length) {
          Object.keys(colors).forEach((color) => {
            const option = document.createElement('option');
            option.value = colors[color].value;
            option.textContent = colors[color].value;
            option.dataset.featuredMedia = colors[color].featuredMedia?.src;

            if (firstAvailableVariantColor && option.value === firstAvailableVariantColor) {
              option.selected = true;
            }

            colorsHolder.appendChild(option);
          });

          if (window.drawerRelated[productId].extraColors) {
            window.drawerRelated[productId].extraColors.forEach((extraColor) => {
              extraColor.options.values.forEach((color) => {
                const option = document.createElement('option');
                option.value = '';
                option.textContent = color;
                option.dataset.redirectTo = extraColor.url;

                colorsHolder.appendChild(option);
              });
            });
          }

          colorsHolder.addEventListener('change', handleSwatchChange);
          colorsHolder.addEventListener('change', changeImage);
          colorsHolder.dispatchEvent(new Event('change'));
        } else {
          colorsHolder.remove();
        }

        if (sizes) {
          sizes.forEach((size) => {
            const option = document.createElement('option');
            option.value = size;
            option.textContent = size;

            if (firstAvailableVariantSize && option.value === firstAvailableVariantSize) {
              option.selected = true;
            }

            sizesHolder.appendChild(option);
          });

          sizesHolder.addEventListener('change', handleSwatchChange);
          sizesHolder.dispatchEvent(new Event('change'));
        } else {
          sizesHolder.remove();
        }

        addToCartButton.addEventListener('click', addToCart);
      });
    }
  })();

  // Blog
  (() => {
    if (!document.body.classList.contains('template-blog')) {
      return;
    }

    document.querySelectorAll('.grid--main > .grid__item a').forEach((a) => {
      a.addEventListener('click', function (evt) {
        evt.preventDefault();
      })
    });

    if (document.documentElement.clientWidth > 768) {
      let maxHeight = 0;
      document.querySelectorAll('.grid--main .article__grid-meta').forEach((gridItemMeta) => {
        // gridItemMeta.style.display = 'block';

        if (gridItemMeta.clientHeight > maxHeight) {
          maxHeight = gridItemMeta.clientHeight;
        }

        // gridItemMeta.style.display = 'none';
      });
      if (maxHeight > 0) {
        document.querySelectorAll('.grid--main .article__grid-meta').forEach((gridItemMeta) => {
          gridItemMeta.style.height = `${maxHeight}px`;
        });
      }
    }
  })();

  // Wishlist
  (() => {
    if (!document.body.classList.contains('template-wishlist')) {
      return;
    }

    const drawerCart = new theme.CartDrawer(true);

    const addToCart = (evt) => {
      evt.preventDefault();

      const id = evt.target.dataset.wkMoveToCart;

      if (!id) {
        return;
      }

      const select = document.getElementById(`wk-option-select-${id}`);

      if (!select) {
        return;
      }

      const variantId = select.value;

      if (!variantId) {
        return;
      }

      evt.target.disabled = true;

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: `id=${variantId}`,
        dataType: 'json'
      }).then(() => {
        // errorHolder.textContent = '';

        theme.cart.getCart().then((cart) => {
          drawerCart.buildCart(cart, true);

          evt.target.disabled = false;
        });
      }, (response) => {
        // errorHolder.textContent = response.responseJSON.description;

        evt.target.disabled = false;
      });
    };

    const wishlistOnLoad = () => {
      document.querySelectorAll('.wk-add-to-cart').forEach((button) => {
        button.addEventListener('click', addToCart);
      });
    };

    let intervalCheck = setInterval(() => {
      if (document.querySelector('.wishlist-collection')) {
        clearInterval(intervalCheck);
        intervalCheck = null;
        wishlistOnLoad();
      }
    }, 500);
  })();

  // Klaviyo
  (() => {
    KlaviyoSubscribe.attachToForms('#footer__newsletter', {
      success_message: 'Thank you for signing up!',
      error: function (form) {
      },
      extra_properties: {
        $source: '$embed',
        $method_type: "Klaviyo Form",
        $method_id: 'embed',
      },
      hide_form_on_success: false,
      success: function (form) {
      }
    });

    KlaviyoSubscribe.attachToForms('#header__newsletter', {
      success_message: 'Thank you for signing up!',
      error: function (form) {
      },
      extra_properties: {
        $source: '$embed',
        $method_type: "Klaviyo Form",
        $method_id: 'embed',
      },
      hide_form_on_success: false,
      success: function (form) {
      }
    });
  })();

  // Back to top
  (() => {
    const backToTop = document.querySelector('.back-to-top__holder');

    if (!backToTop) {
      return;
    }

    const scrollToTop = (evt) => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    };

    // Save scroll position
    let lastKnownScrollPosition = 0;
    let ticking = false;

    function doScroll(scrollPos) {
      if (scrollPos > 580) {
        backToTop.style.opacity = 1;
      } else {
        backToTop.style.opacity = 0;
      }
    }

    document.addEventListener('scroll', function (e) {
      lastKnownScrollPosition = window.scrollY;

      if (!ticking) {
        window.requestAnimationFrame(function () {
          doScroll(lastKnownScrollPosition);
          ticking = false;
        });

        ticking = true;
      }
    });

    backToTop.addEventListener('click', scrollToTop);
  })();

  // Photoswipe
  (() => {
    if (!document.body.classList.contains('template-product')) {
      return;
    }

    document.body.addEventListener("keydown", (event) => {
      if (event.isComposing) {
        return;
      }

      if (event.key === 'ArrowLeft') {
        document.querySelector('.product__main-photos.pdp-slideshow .slick-prev.slick-arrow')?.click();
      } else if (event.key === 'ArrowRight') {
        document.querySelector('.product__main-photos.pdp-slideshow .slick-next.slick-arrow')?.click();
      }
    });

    document.querySelector('.pswp__button--arrow--right')?.addEventListener('click', () => {
      document.querySelector('.product__main-photos.pdp-slideshow .slick-next.slick-arrow')?.click();
    });

    document.querySelector('.pswp__button--arrow--left')?.addEventListener('click', () => {
      document.querySelector('.product__main-photos.pdp-slideshow .slick-prev.slick-arrow')?.click();
    });
  })();
}
